<script>
export default {
  name: 'WorkPlace'
}
</script>
<script setup>
import { ref, onMounted, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import WorkOrder from './components/WorkOrder/index.vue'
import Container from './Container/index'
import Empty from './Empty.vue'
import { isEmpty } from './hooks/workOrder'

const store = useStore()
const route = useRoute()
const container = ref(true)
const loading = ref(false)
const activeKey = ref(2)
// const guideConsultGroupId = ref('0')
// const doctorDaGroupId = ref('0')
// provide('groupId', groupId)
// provide('privateId', privateId)
// provide('guideConsultGroupId', guideConsultGroupId)
// provide('doctorDaGroupId', doctorDaGroupId)
onMounted(async () => {
  activeKey.value = +route.query.activeKey || 2
})
/**
 * FIXME:转圈状态一闪接口发起请求时接收第一次emit让缺损页loading,第二次有数据加载页面
 * @description: 立即处理的响应事件
 * @param {Object} res
 * @param {Boolean} load
 */
function doItNow({ res, load }) {
  loading.value = load
  isEmpty.value = true
  if (!res) return
  isEmpty.value = false
}
const workStatus = computed(() => store.getters.workStatus)
watch(
  () => workStatus.value,
  val => {
    val === 1 ? (isEmpty.value = true) : ''
  }
)
</script>
<template>
  <div class="work-place clearfix">
    <!-- <a-spin :spinning="loading"> -->
    <!-- 左侧 -->
    <work-order
      :isEmpty="isEmpty"
      class="work-place_left"
      @doItNow="doItNow"
      :activeKey="activeKey"
    />
    <!-- </a-spin> -->
    <!-- 右侧 -->
    <main class="work-place_right">
      <!-- 坐班中 -->
      <a-spin v-if="workStatus !== 1" :spinning="loading">
        <empty v-if="isEmpty" />
        <Container v-else ref="container" />
      </a-spin>
      <!-- 休息中 -->
      <div class="empty" v-else>
        <auth-img class="empty-img" src="@/assets/img/rest-work.png" alt="缺损" />
        <div class="empty-text">当前为休息状态，无法处理待办，请切换至坐班状态</div>
      </div>
    </main>
  </div>
</template>

<style lang="scss" scoped>
.work-place {
  // 调整 spin 加载中样式
  display: flex;
  height: 100%;
  width: 100%;
  overflow: hidden;
  &_left {
    flex-shrink: 0;
  }
  &_right {
    border-left: 1px solid #f0f0f0;
    ::v-deep(.ant-spin-nested-loading),
    ::v-deep(.ant-spin-spinning),
    ::v-deep(.ant-spin-container) {
      width: 100%;
      height: 100%;
    }
    height: 100%;
    position: relative;
    flex-grow: 2;
    flex-shrink: 1;
    .empty {
      width: 330px;
      height: 250px;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      text-align: center;
      &-text {
        height: 20px;
        font-size: 14px;
        color: #999999;
        .pending-count {
          color: cornflowerblue;
        }
      }
    }
  }
}
.clearfix::after {
  content: '';
  display: block;
  clear: both;
  overflow: hidden;
}
</style>
